import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconUnarchiveGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M0.96875 8H15.0312"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.46875 14.5625L15.0312 8L8.46875 1.4375"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconUnarchiveSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconUnarchiveGroup {...props} />
    </svg>
  );
};
